// Bloque 6 FOR DECI · trabajo sin cobertura en la tableta.
// IndexedDB con tres almacenes: cache (respuestas GET por URL), queue (revisiones pendientes de enviar) y files (fotos tomadas sin conexión).
const DB_NAME = "gmao-offline";
const DB_VERSION = 1;
let dbPromise = null;

function openDb() {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const d = req.result;
      if (!d.objectStoreNames.contains("cache")) d.createObjectStore("cache");
      if (!d.objectStoreNames.contains("queue")) d.createObjectStore("queue");
      if (!d.objectStoreNames.contains("files")) d.createObjectStore("files");
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbPromise;
}

async function tx(store, mode, fn) {
  const d = await openDb();
  return new Promise((resolve, reject) => {
    const t = d.transaction(store, mode);
    const s = t.objectStore(store);
    const r = fn(s);
    t.oncomplete = () => resolve(r && "result" in r ? r.result : undefined);
    t.onerror = () => reject(t.error);
  });
}
const get = (store, key) => tx(store, "readonly", (s) => s.get(key));
const put = (store, key, val) => tx(store, "readwrite", (s) => s.put(val, key));
const del = (store, key) => tx(store, "readwrite", (s) => s.delete(key));
const all = (store) => tx(store, "readonly", (s) => s.getAll());
const keys = (store) => tx(store, "readonly", (s) => s.getAllKeys());

export const isOffline = () => typeof navigator !== "undefined" && navigator.onLine === false;

// URLs GET que se guardan para consulta sin cobertura (solo lo necesario para revisar: nada económico).
const CACHEABLE = [/^\/elements\?/, /^\/installations\/[^/?]+$/, /^\/installations(\?|$)/, /^\/companies(\?|$)/, /^\/element-types/, /^\/revision-sessions\/active\?/,
  /^\/revision-sessions(\?|$)/, /^\/incidents\?session_id=/, /^\/incidents\?element_id=/, /^\/inspections\?/, /^\/spare-parts(\?|$)/, /^\/auth\/me$/, /^\/catalog-relations\/plant-spares/];
const ECONOMIC_KEYS = ["coste_referencia", "precio_compra", "precio_unitario", "precios_vigentes", "precio_propio", "precio_venta"];

export const isCacheable = (url) => CACHEABLE.some((re) => re.test(url));
const stripEconomic = (data) => Array.isArray(data) ? data.map((d) => { const o = { ...d }; ECONOMIC_KEYS.forEach((k) => delete o[k]); return o; }) : data;

export const cacheSet = (url, data) => put("cache", url, { data: url.startsWith("/spare-parts") ? stripEconomic(data) : data, at: new Date().toISOString() }).catch(() => {});
export const cacheGet = (url) => get("cache", url).catch(() => null);
export const cachePatch = async (url, fn) => { const cur = await cacheGet(url); if (cur) await cacheSet(url, fn(cur.data)); };

export const queueAdd = (op) => put("queue", op.op_id, op);
export const queueUpdate = queueAdd;
export const queueRemove = (id) => del("queue", id);
export const queueList = () => all("queue").then((l) => (l || []).sort((a, b) => (a.client_at || "").localeCompare(b.client_at || ""))).catch(() => []);

export const fileAdd = (id, blob, name) => put("files", id, { blob, name, at: new Date().toISOString() });
export const fileGet = (id) => get("files", id).catch(() => null);
export const fileRemove = (id) => del("files", id);
export const fileKeys = () => keys("files").catch(() => []);
export const isTempFile = (id) => typeof id === "string" && id.startsWith("offline-file-");

// Plano/foto guardados en el dispositivo → URL de objeto para <img>. Si no está guardado devuelve la URL normal.
const objectUrls = new Map();
export async function fileSrc(fileId, networkUrl) {
  if (!fileId) return null;
  if (!isOffline() && !isTempFile(fileId)) return networkUrl;
  if (objectUrls.has(fileId)) return objectUrls.get(fileId);
  const f = await fileGet(fileId);
  if (!f?.blob) return networkUrl;
  const u = URL.createObjectURL(f.blob);
  objectUrls.set(fileId, u);
  return u;
}

// Estado del paquete descargado por planta (fecha y nº de elementos) para mostrarlo en Revisiones.
export const packageInfoSet = (installId, info) => put("cache", `package:${installId}`, info).catch(() => {});
export const packageInfoGet = (installId) => get("cache", `package:${installId}`).catch(() => null);

const listeners = new Set();
export const onOfflineChange = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
export const notifyOfflineChange = () => listeners.forEach((fn) => { try { fn(); } catch { /* noop */ } });
